var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningTriangleFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.277 2.122a1.5 1.5 0 0 0-2.555 0L.512 12.214A1.5 1.5 0 0 0 1.789 14.5H14.21a1.5 1.5 0 0 0 1.278-2.286L9.278 2.122ZM7.25 8.5a.75.75 0 0 0 1.5 0V6a.75.75 0 1 0-1.5 0v2.5Zm-.25 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningTriangleFilled);
export default ForwardRef;